import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({
    name: 'safeHtml',
    pure: true
})

export class SafeHtmlPipe implements PipeTransform {
    
    constructor(private _sanitize: DomSanitizer){}

    transform(html: any) 
    {
        return this._sanitize.bypassSecurityTrustResourceUrl(html);
    }
}